export const mustAnswerToSubmitPollRenderTypes = ['email'];